// extracted by mini-css-extract-plugin
export default {"sentence":"PixelSentence_sentence__4BSq2","word":"PixelSentence_word__KEzhF","wordsContainer":"PixelSentence_wordsContainer__ioqia"};